const QueryString = require('query-string');

module.exports = (search) => {

    if (typeof search === 'undefined') {
        search = window.location.search;
    }

    if (search && typeof search === 'object') {
        search = search.search;
    }

    return QueryString.parse(search || '');
};
